import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { UpdateRoot } from './App';
import { initStorage } from './storage';
const root = ReactDOM.createRoot(document.getElementById('root'));
// Saved sheets are loaded from IndexedDB before the app first renders
initStorage().finally(() => root.render(<React.StrictMode><App /><UpdateRoot /></React.StrictMode>));

// Installable app + offline support (see public/sw.js)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
}
